import { apiRequest } from "../utils/useAPIRequest";
import constant from "../utils/constant";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { queryClient } from "../App";
import { marketersStore } from "../stores";

const useGetMarketers = (marketersTableQuery, filterQuery, searchQuery) => {
  const query = useMemo(() => {
    if (searchQuery && filterQuery) {
      return `${marketersTableQuery}&${filterQuery}&search=${searchQuery}`;
    } else if (searchQuery) {
      return `${marketersTableQuery}&search=${searchQuery}`;
    } else if (filterQuery) {
      return `${marketersTableQuery}&${filterQuery}`;
    } else {
      return marketersTableQuery;
    }
  }, [filterQuery, marketersTableQuery, searchQuery]);

  return useQuery({
    queryKey: ["getMarketers", query],
    queryFn: () => {
      return apiRequest({
        url: `/marketers/admin?${query}`,
        method: "get",
      });
    },
    keepPreviousData: true,
  });
};
const useGetMarketersBusinesses = (
  marketersTableQuery,
  filterQuery,
  searchQuery
) => {
  const query = useMemo(() => {
    if (searchQuery && filterQuery) {
      return `${marketersTableQuery}&${filterQuery}&search=${searchQuery}`;
    } else if (searchQuery) {
      return `${marketersTableQuery}&search=${searchQuery}`;
    } else if (filterQuery) {
      return `${marketersTableQuery}&${filterQuery}`;
    } else {
      return marketersTableQuery;
    }
  }, [filterQuery, marketersTableQuery, searchQuery]);

  return useQuery({
    queryKey: ["getMarketersBusinesses", query],
    queryFn: () => {
      return apiRequest({
        url: `/marketers/admin/commission?${query}`,
        method: "get",
      });
    },
    keepPreviousData: true,
  });
};
const useGetBusinessPartnersBusinesses = (
  businessPartnerTableQuery,
  filterQuery,
  searchQuery
) => {
  const query = useMemo(() => {
    if (searchQuery && filterQuery) {
      return `${businessPartnerTableQuery}&${filterQuery}&search=${searchQuery}`;
    } else if (searchQuery) {
      return `${businessPartnerTableQuery}&search=${searchQuery}`;
    } else if (filterQuery) {
      return `${businessPartnerTableQuery}&${filterQuery}`;
    } else {
      return businessPartnerTableQuery;
    }
  }, [filterQuery, businessPartnerTableQuery, searchQuery]);

  return useQuery({
    queryKey: ["GetBusinessPartnersBusinesses", query],
    queryFn: () => {
      return apiRequest({
        url: `/marketers/admin/commission?${query}`,
        method: "get",
      });
    },
    keepPreviousData: true,
  });
};

const getMarketersAnalysis = async (params) => {
  let url = "/marketers/admin/partner-analysis";
  const searchParams = new URLSearchParams();

  if (params?.type !== undefined && params?.type !== "") {
    searchParams.append("type", params?.type);
  }
  if (params?.business !== undefined && params?.business !== "") {
    searchParams.append("business", params?.business);
  }
  if (params?.marketer !== undefined && params?.marketer !== "") {
    searchParams.append("marketer", params?.marketer);
  }

  const queryString = searchParams.toString();
  if (queryString) {
    url += `?${queryString}`;
  }

  const { status, errorMessage, data } = await apiRequest({
    url: url,
    method: "get",
  });

  if (status === constant.Success) {
    marketersStore.setMarketerAnalysis(data);
    return { status };
  }

  return { status, errorMessage };
};

export default {
  useGetMarketers,
  useGetMarketersBusinesses,
  useGetBusinessPartnersBusinesses,
  getMarketersAnalysis,
};
